import mutations from './mutations'

export default {
  namespaced: true,
  state: () => ({
    color: 'blue',
    name: window.location.host,
    version: {},
    env: {
      name: '',
      icon: '',
      color: ''
    }
  }),
  mutations: mutations
}
